<div class="submit-button__wrapper" [class.ready]="ready">
  <button
    [type]="loading ? 'button' : 'submit'"
    mat-flat-button
    color="primary"
    class="submit-button"
    [class.loading]="loading"
  >
    <span class="submit-button__text">
      <ng-content></ng-content>
    </span>
  </button>
</div>
